import React from 'react';
import { 
  profile_tabs_posts,
  profile_tabs_projects,
  profile_tabs_learning,
  profile_tabs_teaching,
  profile_tabs_roadmaps
} from '@paraglide/messages';
import { TabNav } from "@edusense/shared-ui-layout";
import { TabNavWrapper, TabNavInner } from '../Profile.styles';
import { ScreenCompactMode, ProfileTabType } from '../base';
import { PROFILE_PAGE_TEST_IDS } from '@edusense/shared-constants';

interface TabItem {
  id: string;
  label: string;
}

interface ProfileTabsProps {
  activeTab: ProfileTabType;
  onTabChange: (tabId: string) => void;
  screenCompactMode: ScreenCompactMode;
}

export const ProfileTabs: React.FC<ProfileTabsProps> = ({
  activeTab,
  onTabChange,
  screenCompactMode
}) => {

  const profileTabs: TabItem[] = [
    { id: 'tweets', label: profile_tabs_posts(), dataTestId: PROFILE_PAGE_TEST_IDS.PROFILE_TAB_TWEETS },
    { id: 'projects', label: profile_tabs_projects(), dataTestId: PROFILE_PAGE_TEST_IDS.PROFILE_TAB_PROJECTS },
    { id: 'learning', label: profile_tabs_learning(), dataTestId: PROFILE_PAGE_TEST_IDS.PROFILE_TAB_LEARNING },
    { id: 'teaching', label: profile_tabs_teaching(), dataTestId: PROFILE_PAGE_TEST_IDS.PROFILE_TAB_TEACHING },
    { id: 'roadmaps', label: profile_tabs_roadmaps(), dataTestId: PROFILE_PAGE_TEST_IDS.PROFILE_TAB_ROADMAPS }
  ];

  return (
    <TabNavWrapper className="tab-nav-wrapper">
      <TabNavInner>
        <TabNav 
          tabs={profileTabs} 
          activeTabId={activeTab} 
          onTabChange={onTabChange}
        />
      </TabNavInner>
    </TabNavWrapper>
  );
};
